import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { cart } from "@/theme/Cart";

@Component
export class BrowsingPreference extends ThemeComponent {

    @Ref() toggleButtons!: HTMLButtonElement[];

    init() {
        if (this.toggleButtons) {
            for (const button of this.toggleButtons) {
                const preference = button.getAttribute('data-preference');
                if (preference) {
                    this.$listen(button, 'click', () => {
                        cart.updateAttributes({
                            preference: preference
                        }).then(() => {
                            document.location.href = '/';
                        }).catch((error) => {
                            this.$log.error('There was an error setting the browsing preference');
                        });
                    });
                }
            }
        }
    }
}
